// extracted by mini-css-extract-plugin
module.exports = {"root":"StageGrid_root__S6eIr"};